// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"ec9fe2e9","1434":"707d702e","3572":"ec9fe2e9","3829":"6b0439fd","4571":"d17e2468","5157":"86b7a366","7237":"38db8e93","7733":"a9c6eba1"}[chunkId] + ".chunk.css";
};